import React, { useEffect, useRef } from 'react';
import Bugsnag from '@bugsnag/js';
import styled from 'styled-components';
import { setCookieByName } from '@99designs/browser';
import { trackLink } from '../../../lib/events';

export async function fetchPromoBar(urlSlug: string, host: string) {
    try {
        const response = await fetch(`https://${host}/noticebar`);
        if (!response.ok) {
            return null;
        }
        return (await response.json()) || null;
    } catch (error) {
        Bugsnag.notify(error);
        Bugsnag.notify(new Error(`Error fetching noticebar - ${error.message}`), (event) => {
            event.context = `urlSlug="${urlSlug}"`;
        });
        return null;
    }
}

const StyledPromoBar = styled.div`
    a:hover,
    a:focus {
        color: inherit;
    }
`;

export type PromoBarContentType = {
    name: string;
    content: string;
    cookieExpiry: number;
};

export function PromoBar({ promoBar }: { promoBar: PromoBarContentType }) {
    const promoBarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (promoBarRef.current) {
            const dismissButton = promoBarRef.current.querySelector('[data-promo-bar-dismiss]');
            const promoBarCTAs = promoBarRef.current.querySelectorAll(
                'a.promo-bar__message__action'
            );

            if (promoBarCTAs.length > 0) {
                promoBarCTAs.forEach((CTA) => {
                    CTA.addEventListener('click', (e: MouseEvent) => {
                        trackLink(e, 'Clicked Notice Bar Link', {
                            notice_bar_name: promoBar.name,
                        });
                    });
                });
            }

            if (dismissButton) {
                dismissButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    promoBarRef.current?.setAttribute('data-hidden', '');
                    setCookieByName({
                        cookieName: promoBar.name,
                        expiryInMinutes: promoBar.cookieExpiry * 24 * 60,
                        value: '1',
                    });
                });
            }
        }
    }, [promoBar]);

    return (
        <StyledPromoBar
            ref={promoBarRef}
            dangerouslySetInnerHTML={{ __html: promoBar.content || '' }}
        />
    );
}
